import { create } from "zustand";
import { IUser } from "@/common/api/services/types";

interface IUserState {
  sessionId: string | null;
  currentUser?: IUser | null;
  setCurrentUser: (currentUser: IUser | null) => void;
  setSessionId: (sessionId: string) => void;
}

export const useUserStore = create<IUserState>(
  (set) => ({
    sessionId: null,
    setCurrentUser: (currentUser: IUser | null) => set(() => ({ currentUser })),
    setSessionId: (sessionId: string) => set(() => ({ sessionId })),
  }),
);
